module.exports = __webpack_public_path__ + "static/media/gal0417.d01a7ad6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal04/gal0417.jpg
// module id = 376
// module chunks = 0